import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { ROLES } from '../constants/enums/roles';
import { useRoleGetter } from '../helpers/getUserInfo';
import { UserStateProps } from '../interfaces/modules.interface';
import {
  admin,
  getActiveUser,
  kancelar,
  konkurrent,
  pedagog,
  pjesmarres,
  specialistFF,
  specialistFv,
  student,
} from '../components/common/common-functions/common-functions';
import { useAuth } from './use-auth';
import { allAnetarKomisioni } from '../constants/all-anetar-komisioni';

export const useRedirect = (setCollapsed?: (value: boolean) => void) => {
  const ffRoles = [specialistFF, pedagog, student];

  const userRole = useRoleGetter() as ROLES;
  const navigate = useNavigate();

  const { data: loggedInUser } = useAuth(!userRole);

  const selectorRole = useSelector((state: UserStateProps) => state.activeUser);

  const role = useMemo(
    () => (selectorRole.length > 0 ? selectorRole : getActiveUser()),
    [selectorRole, getActiveUser],
  );

  const redirectUrl = useCallback(() => {
    if (!loggedInUser) return false;

    if (loggedInUser.rolet?.length > 1 && !role) {
      navigate('/modulet');
      return true;
    }

    if (
      userRole &&
      (userRole === konkurrent || allAnetarKomisioni.includes(userRole))
    ) {
      navigate('/konkurrime');
      setCollapsed?.(false);
      return true;
    }

    if (
      role === admin ||
      role === kancelar ||
      (userRole === admin && loggedInUser.rolet.length === 1) ||
      (userRole === kancelar && loggedInUser.rolet.length === 1)
    ) {
      navigate('/administrim-konkurrim');
      setCollapsed?.(false);
      return true;
    }

    if (
      role === specialistFv ||
      (loggedInUser.rolet.includes(specialistFv) &&
        loggedInUser.rolet.length === 1)
    ) {
      navigate('/administrim-formimiVazhdues');
      setCollapsed?.(false);
      return true;
    }

    if (
      role === pjesmarres ||
      (userRole === pjesmarres &&
        loggedInUser.rolet.length === 1 &&
        !loggedInUser.firstLogIn)
    ) {
      navigate('/kalendari');
      setCollapsed?.(false);
      return true;
    }

    if (
      ffRoles.includes(role as ROLES) ||
      ([specialistFF, pedagog, student].includes(userRole) &&
        loggedInUser.rolet.length === 1)
    ) {
      navigate('/lende-mesimore');
      setCollapsed?.(false);
      return true;
    }

    return false;
  }, [loggedInUser, role, userRole]);

  return redirectUrl;
};
